import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../lib/api';
import { useAuth } from '../context/AuthContext';
import MemberLayout from '../components/MemberLayout';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Progress } from '../components/ui/progress';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../components/ui/accordion';
import { CheckCircle2, Circle, Lock, FileText, HelpCircle } from 'lucide-react';

export default function Academy() {
  const { isActive } = useAuth();
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => { api.get('/academy/course').then(r => setData(r.data)).catch(()=>{}); }, []);

  if (!data) return <MemberLayout><div className="h-64 flex items-center justify-center text-muted-foreground">Memuat kurikulum...</div></MemberLayout>;

  return (
    <MemberLayout>
      <div className="mb-6">
        <h1 className="font-display text-2xl sm:text-3xl font-bold">{data.course.title}</h1>
        <p className="text-muted-foreground mt-1">{data.course.description}</p>
      </div>

      <Card className="p-5 mb-6">
        <div className="flex items-center justify-between mb-2"><span className="font-semibold">Total Progress</span><span className="tabular-nums text-sm">{data.progress.percent}% — {data.progress.completed_lessons}/{data.progress.total_lessons}</span></div>
        <Progress value={data.progress.percent} className="h-3" />
      </Card>

      {!isActive && (
        <Card className="p-5 mb-6 border-amber-200 bg-amber-50/60"><div className="flex items-center gap-2 text-amber-800"><Lock className="h-4 w-4" /> Membership tidak aktif — konten lesson terkunci.</div></Card>
      )}

      <Accordion type="multiple" className="space-y-3">
        {data.chapters.map((ch) => (
          <AccordionItem key={ch.chapter_id} value={ch.chapter_id} className="border rounded-xl px-4 bg-card">
            <AccordionTrigger className="hover:no-underline">
              <div className="flex-1 text-left pr-4">
                <div className="font-semibold">{ch.title}</div>
                <div className="text-xs text-muted-foreground mt-1">{ch.lessons_completed}/{ch.lessons_total} lesson selesai</div>
              </div>
            </AccordionTrigger>
            <AccordionContent>
              <div className="space-y-1 pb-2">
                {ch.lessons.map(l => (
                  <button key={l.lesson_id} disabled={!isActive} onClick={() => navigate(`/academy/lesson/${l.lesson_id}`)}
                    data-testid={`lesson-item-${l.lesson_id}`}
                    className="w-full flex items-center gap-3 rounded-lg px-3 py-2.5 text-left text-sm hover:bg-muted disabled:opacity-50 transition-colors">
                    {l.completed ? <CheckCircle2 className="h-4 w-4 text-emerald-600" /> : <Circle className="h-4 w-4 text-muted-foreground" />}
                    <FileText className="h-4 w-4 text-muted-foreground" />
                    <span className="flex-1">{l.code} {l.title}</span>
                  </button>
                ))}
                <Button variant="outline" size="sm" disabled={!isActive} className="mt-2 ml-3" onClick={() => navigate(`/academy/quiz/${ch.quiz_id}`)} data-testid={`quiz-button-${ch.quiz_id}`}>
                  <HelpCircle className="h-4 w-4 mr-1" /> Quiz Chapter
                </Button>
              </div>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </MemberLayout>
  );
}
